import { createStyles } from 'antd-style';

import splitterIcon from '../resources/img/splitter.svg';
import { ThemeSpaces } from '../theme';

export const useMonitorPageStyles = createStyles(
  ({ token }, { innerContent } = {}) => ({
    monitorPage: {
      [`.${innerContent}`]: {
        justifyContent: 'flex-start',
        marginTop: ThemeSpaces.SPACE_NORM0_5,
      },
    },
    searchTitleRow: {
      '&&': {
        marginBottom: ThemeSpaces.SPACE_NORM0_5,
      },
    },
    searchTitleCol: {
      '.ant-form-item': {
        marginBottom: 0,
      },
    },
    searchInput: {
      width: 400,

      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 250,
      },
    },
    monitorPageJobs: {
      '&& .ant-splitter-bar-dragger': {
        '&::before': {
          content: 'none',
        },

        '&::after': {
          background: `url('${splitterIcon}') no-repeat center`,
          height: 20,
          width: 12,
          borderRadius: token.borderRadiusSM,
        },
      },
    },
    mapViewFirstPanel: {
      '&&': {
        overflow: 'hidden',
        paddingLeft: 0,
        paddingRight: ThemeSpaces.SPACE_NORM_20,
      },
    },
    mapViewSecondPanel: {
      '&&': {
        paddingLeft: ThemeSpaces.SPACE_NORM,
        paddingRight: 0,
      },
    },
  })
);
